var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_287_2829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1 11.9926V12.8926C14.1 13.37 13.9103 13.8278 13.5728 14.1654C13.2352 14.5029 12.7774 14.6926 12.3 14.6926H3.3C2.82261 14.6926 2.36477 14.5029 2.02721 14.1654C1.68964 13.8278 1.5 13.37 1.5 12.8926V6.5926C1.5 6.11521 1.68964 5.65738 2.02721 5.31981C2.36477 4.98224 2.82261 4.7926 3.3 4.7926H12.3C12.7774 4.7926 13.2352 4.98224 13.5728 5.31981C13.9103 5.65738 14.1 6.11521 14.1 6.5926V7.4926",
    stroke: "#002342",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3001 4.79252L10.9026 1.99772C10.8498 1.89196 10.7766 1.79765 10.6873 1.72017C10.598 1.64269 10.4943 1.58357 10.3821 1.54619C10.27 1.5088 10.1516 1.49387 10.0336 1.50227C9.91571 1.51067 9.80057 1.54222 9.69485 1.59512L3.30005 4.79252",
    stroke: "#002342",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0999 11.9927C14.3385 11.9927 14.5675 11.8979 14.7363 11.7291C14.9051 11.5603 14.9999 11.3314 14.9999 11.0927V8.39268C14.9999 8.154 14.9051 7.92504 14.7363 7.75626C14.5675 7.58748 14.3385 7.49268 14.0999 7.49268H11.8499C11.2531 7.49268 10.6808 7.72974 10.2588 8.15166C9.83691 8.57364 9.59985 9.14592 9.59985 9.74268C9.59985 10.3394 9.83691 10.9117 10.2588 11.3337C10.6808 11.7556 11.2531 11.9927 11.8499 11.9927H14.0999Z",
    stroke: "#002342",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.85 9.96746C11.7257 9.96746 11.625 9.86672 11.625 9.74246C11.625 9.6182 11.7257 9.51746 11.85 9.51746",
    stroke: "#002342",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8501 9.96746C11.9744 9.96746 12.0751 9.86672 12.0751 9.74246C12.0751 9.6182 11.9744 9.51746 11.8501 9.51746",
    stroke: "#002342",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_2829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.767168a7774f0417a94a5a25c1b8df07.svg";
export { ForwardRef as ReactComponent };